const normalizarValorFinal = (valor) => {
    if (valor === null || valor === undefined) return '';
    return valor;
};

export const serializarProductosAjuste = (productos = []) => {
    const campos = {};

    productos.forEach((producto, indiceProducto) => {
        const esNuevo = !producto.id_producto;
        const prefijoProducto = `productos[${indiceProducto}]`;

        campos[`${prefijoProducto}[id_producto]`] = esNuevo ? '' : normalizarValorFinal(producto.id_producto);

        if (esNuevo) {
            campos[`${prefijoProducto}[nombre]`] = normalizarValorFinal(producto.nombre);
            campos[`${prefijoProducto}[codigo]`] = normalizarValorFinal(producto.codigo);
            campos[`${prefijoProducto}[descripcion]`] = normalizarValorFinal(producto.descripcion);
        }

        (producto.proveedores || []).forEach((proveedor, indiceProveedor) => {
            const prefijoProveedor = `${prefijoProducto}[proveedores][${indiceProveedor}]`;

            campos[`${prefijoProveedor}[id_proveedor]`] = normalizarValorFinal(proveedor.id_proveedor);
            campos[`${prefijoProveedor}[codigo]`] = normalizarValorFinal(proveedor.codigo);
            campos[`${prefijoProveedor}[precio_publico]`] = normalizarValorFinal(proveedor.precio_publico);
            campos[`${prefijoProveedor}[precio_minimo]`] = normalizarValorFinal(proveedor.precio_minimo);
            campos[`${prefijoProveedor}[precio_liquidacion]`] = normalizarValorFinal(proveedor.precio_liquidacion);
            campos[`${prefijoProveedor}[precio_historico]`] = normalizarValorFinal(proveedor.precio_historico);
        });

        (producto.inventarios || []).forEach((inventarioItem, indiceInventario) => {
            const prefijoInventario = `${prefijoProducto}[inventarios][${indiceInventario}]`;

            campos[`${prefijoInventario}[id_area]`] = normalizarValorFinal(inventarioItem.id_area);
            campos[`${prefijoInventario}[id_organizador]`] = normalizarValorFinal(inventarioItem.id_organizador);
            campos[`${prefijoInventario}[id_ubicacion]`] = normalizarValorFinal(inventarioItem.id_ubicacion);
            campos[`${prefijoInventario}[cantidad]`] = normalizarValorFinal(inventarioItem.cantidad);
        });
    });

    return campos;
};
